module.exports = __webpack_public_path__ + "static/media/edwards.a21e5e63.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/edwards.png
// module id = 946
// module chunks = 0